<template>
    <div>
        <PageHeader title="Podcasts">
            <template #meta>Popular Somali podcasts</template>
        </PageHeader>
        <div v-if="podcasts" class="-mx-2.5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            <MediaCard v-for="podcast in podcasts" :key="podcast.id" :href="'/podcast/' + podcast.id"
                :image="podcast.image" :title="podcast.title" :subtitle="podcast.host" />
        </div>
    </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import MediaCard from "@/components/ui/MediaCard.vue";
defineProps({ podcasts: Object });
</script>
<script>
import { defineAsyncComponent } from 'vue'
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
    beforeMount() {
        document.title = "Somali Podcasts"
    },
}</script>